//
// Sticky add to cart button
//

define([
	'jquery',
	'handlebars-core',
	'shared.main.screen',
	'pubsub',
	'shared.main.resize',
	'foundation.reveal',
	'wcs.tooltip'
], function($, HBCore, screenSize) {

	"use strict";

	var PLUGIN_IDENTIFIER = "StickyAddToCart",
		DEBUG = window.DEBUG || false;

	var StickyAddToCart = function( element, options ) {
		this.element = element;
		this.options = options || {};
		this.metadata = $(this.element).data('sticky-options');
		this.data = {};
		this.defaults = {
			elementSelector: '.add-to-bag-js',
			template: 'html.add-to-cart.sticky',
			showFor: [
				'small'
			],
			location: { // Where the sticky button is in relation to the Add to Cart button
				// hide | top | bottom
				above: 'top', // ATC button is above the top of the page
				inview: 'hide', // ATC button is in view
				below: 'hide' // ATC button is below the fold
			},
			customLocations: [],
			buttonText: 'Add to Cart',
			productPrice: {
				enabled: true
			},
			productPromo: {
				enabled: false,
				selector: '.discount-container'
			},
			quantity: {
				enabled: false,
				title: 'Please enter valid quantity',
				label: 'Quantity:',
				default: '1',
				error: 'Please enter valid quantity',
				errorState: false,
				className: '.quantity-js',
				idName: '#sticky-quantity-id'
			},
			img: {
				enabled: true,
				label: false,
				scrollOnClick: false,
			},
			productInfo: {
				enabled: true
			},
			navigation: {
				enabled: false,
				links: [{label: 'Overview',
						 url: '#container-4',
						 modal : false,
						 tooltip : {
						 	enabled: false}
						 },
						 {label: 'Reviews',
						 url : '#pr-review-display',
						 modal : false,
						 tooltip : {
						 	enabled: false}
						 },
						 {label: 'Warranty',
						 modal : false,
						 tooltip : {
						 	enabled: true,
						 	content: 'We stand by our packs for a lifetime and since we\'ve been making packs since 1967, that\'s a guarantee you can stand by.',
						 	className: 'product-content-form-guarantee-tooltip tooltip-js'}
						 }]
			},
			errorMessaging: {
				enabled: false,
				closeAriaLabel: 'Close',
				className: '.errorMessage',
				idName: '#sticky-add-to-cart-error'
			},
			sizeSelection: {
				enabled: false,
				initialLabelSelector: '#buttonAddToBag',
				isDropdown: false,
				label: false,
				sizeAsSeparateContainer: false,
				displayEmpty: false,
				scrollOnClick: false
			},
			containerClass: '.sticky-add-to-cart',
			favoritesButton: {
				enabled: false,
				isWishlist: false,
				isHideOnSizeNotSelect: false,
				icon: "icon-favorite",
				iconOutline: "icon-favorite",
				iconFilled: "icon-favorite-filled",
				iconOutlineAnimatedClass: "favorites-icon-outline-animated",
				iconFilledAnimatedClass: "favorites-icon-filled-animated",
				selector: ".add-to-favorite.favorites-js",
				addFavoritesButtonSelector: "#sticky-favorites-button > .sticky-icon"
			},
			scrollOnAddToCartAction: {
				enabled: false,
				selector: '',
				duration: 'slow',
			},
			scrollToError: {
				enabled: false,
			},
			signInButtonConfig: {
				enabled: false,
				selector: '#signInModalButton',
				hideStickyOnMobile: false, // If Sign in to buy is visible, hide sticky on mobile
			},
			overrideConfig:{}
		};

		this.config = $.extend(true, {}, this.defaults, this.options, this.metadata);
		if (this.config.overrideConfig[screenSize.size()]) {
			this.config = $.extend(true, this.config, this.config.overrideConfig[screenSize.size()]);
		}
		if( this.config.useAddToCartLabel){
			var data;
			if($('#buttonAddToBag').length > 0) {
				data = $('#buttonAddToBag').data();
			} else {
				data = $(this.element).data();
			}
			if (data.addToCartText) {
				this.config.buttonText = data.addToCartText;
			}
		}

		this.$element = $(this.element);
		return this;
	};

	StickyAddToCart.prototype = {
		init: function() {
			var self = this;
			if(DEBUG) console.log('$.fn.StickyAddToCart init');
			this.loadAndCompileTemplate().done(function() {
				if (self.config.signInButtonConfig.enabled) {
					self.$signInButton = $(self.config.signInButtonConfig.selector);
				}
				self.bindEventHandlers();
				self.updateAll();
				self.updateSizeSelection();
				self.updateAddToFavorites();
			});
			return this;
		},

		updateSelectedColorSwatch: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart updateSelectedColorSwatch');
			if( this.config.img.enabled === false){
				return;
			}
			if( this.config.img.useMetaImage === true ){
				var src = $('meta[property="og:image"]').attr("content"),
						$selectedColorSwatch = $('.color-swatches-js').find('.attr-box.selected img');

				this.config.img.src = $selectedColorSwatch.length ? $selectedColorSwatch.data('main') : src;
				this.config.img.alt = $selectedColorSwatch.length ? $selectedColorSwatch.attr('alt') : src;
			}
			else {
				var activeImg = $('.color-swatches-js .selected img');
				this.config.img.src = activeImg.attr('src');
				this.config.img.alt = activeImg.attr('alt');
			}
		},

		updateProductName: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart updateProductName');
			this.config.name = $('h1.product-info-js').text();
		},

		updateProductColor: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart updateProductColor');
			this.config.color = $('.color-swatches-js .selected').data('attribute-value');
		},

		updateProductSize: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart updateProductSize');
			var sizeText = $('.attr-size h2').text() ? $('.attr-size h2').text() + ': ' : '';
			var size = $('#attr-size option:selected:not(.attr-size-deselected-js)').val() || $('.attr-size .attr-box.selected').text();

			if (this.config.sizeSelection.label) {
				this.config.size = size;
			} else {
				this.config.size = size ? sizeText + size : size;
			}
		},

		updateProductPrice: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart updateProductPrice');
			this.config.price = $('.product-content-info-price').html();
		},

		updateProductPromo: function() {
			var self = this;
			if(self.config.productPromo.enabled) {
				self.config.promo = $(self.config.productPromo.selector).html();
			}
		},

		updateProductQuantity: function() {
			if (!this.config.quantity.enabled) {
				return;
			}
			if(DEBUG) console.log('$.fn.StickyAddToCart updateProductQuantity');

			if(this.config.isSticky) {
				this.config.quantity.default = this.config.quantity.stickyValue;
				$('#quantity-item').val(this.config.quantity.default);
			}else {
				this.config.quantity.default = $('#quantity-item').val();
			}
		},

		initSizeSelection: function() {
			var self = this;
			if (!this.config.sizeSelection.enabled) {
				return;
			}
			$.pubsub('subscribe', 'PDP_ADD_TO_CART_SELECTED', function(event, obj) {
				self.updateSizeSelection(obj);
				self.updateAll();
			});

			this.isSizeSelected = false;
			if( $('.attr-size .attribute-value-selected').length > 0 ){
				this.isSizeSelected = true;
			}

			this.config.originalButtonText = this.config.buttonText;
			this.config.sizeSelectionLabel = $(this.config.sizeSelection.initialLabelSelector).data('stickySelectSizeLabel') || $(this.element).data('stickySelectSizeLabel') || LANG_MSG.PDP_STICKY_SELECT_SIZE_LABEL;
			if( this.isSizeSelected === false){
				this.config.buttonText = this.config.sizeSelectionLabel;
			}
		},

		updateAddToFavorites: function() {
			var self = this;
			if (!this.config.favoritesButton.enabled) {
				return;
			}

			// Wishlist feature does not have the favored data
			if(!self.config.favoritesButton.isWishlist) {
				self.$addToFavoritesButtonMain = $(self.config.favoritesButton.selector);
				self.$addToFavoritesButtonSpan = $(self.config.favoritesButton.addFavoritesButtonSelector);
				self.isFavored = !self.$addToFavoritesButtonMain.data().favored;
			}

			self.toggleFavoriteState();
		},

		toggleFavoriteState: function() {
			var self = this;
			self.$addToFavoritesButtonSpan = $(self.config.favoritesButton.addFavoritesButtonSelector);
			if(!self.config.favoritesButton.isWishlist) {
				self.isFavored = !self.isFavored;
				if (self.isFavored === true && self.$addToFavoritesButtonSpan.hasClass(self.config.favoritesButton.iconOutline) === true) {
					self.config.favoritesButton.icon = self.config.favoritesButton.iconFilled;
					self.$addToFavoritesButtonSpan
						.removeClass(self.config.favoritesButton.iconOutline)
						.addClass(self.config.favoritesButton.iconFilled);
					self.triggerAnimation(self.config.favoritesButton.iconFilledAnimatedClass);
				} else if(self.$addToFavoritesButtonSpan.hasClass(self.config.favoritesButton.iconFilled) === true) {
					self.config.favoritesButton.icon = self.config.favoritesButton.iconOutline;
					self.$addToFavoritesButtonSpan
						.removeClass(self.config.favoritesButton.iconFilled)
						.addClass(self.config.favoritesButton.iconOutline);
					self.triggerAnimation(self.config.favoritesButton.iconOutlineAnimatedClass);
				}
			} else {
				// When the favorite button is the wishlist feature
				if(self.isFavored) {
					self.$addToFavoritesButtonSpan
						.removeClass(self.config.favoritesButton.iconOutline)
						.addClass(self.config.favoritesButton.iconFilled);
					self.triggerAnimation(self.config.favoritesButton.iconFilledAnimatedClass);
				}
			}
		},

		triggerAnimation: function(animatedClass) {
			var self = this;

			self.$addToFavoritesButtonSpan.addClass(animatedClass);
			setTimeout(function () {
				self.$addToFavoritesButtonSpan.removeClass(animatedClass);
			}, 700);
		},

		toggleWishlistButtonVisibility: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart toggleWishlistButtonVisibility');
			var self = this;
			self.$addToFavoritesButtonSpan = $(self.config.favoritesButton.addFavoritesButtonSelector);

			if(self.config.favoritesButton.isHideOnSizeNotSelect) {
				if(self.isSizeSelected) {
					self.$addToFavoritesButtonSpan.parent().removeClass('hide');
				} else {
					self.$addToFavoritesButtonSpan.parent().addClass('hide');
				}
			}
		},

		updateSizeSelection: function(object) {
			if (!this.config.sizeSelection.enabled) {
				return;
			}
			if(DEBUG) console.log('$.fn.StickyAddToCart sizeSelection');

			if (object && object.target) {
				var target = $(object.target);
				if (target.hasClass('out-of-stock')) {
					this.isSelectionOutOfStock = true;
				} else {
					this.isSelectionOutOfStock = false;
				}
			} else if(object && object.obj && this.config.sizeSelection.isDropdown) {
				this.isSelectionOutOfStock = false;
				var ele = $(object.obj);
				if(ele.hasClass('out-of-stock')) {
					this.isSelectionOutOfStock = true;
				}
			}

			var sizeAttrCount = $('.attr-size').length;
			var selectedSizeCount = $('.product-content-form-size-btn-label.selected').length;
			if (sizeAttrCount === selectedSizeCount) {
				this.isSizeSelected = true;
			} else {
				this.isSizeSelected = false;
			}

			if (this.isSizeSelected === false) {
				this.config.buttonText = this.config.sizeSelectionLabel;
			} else {
				this.config.buttonText = this.config.originalButtonText;
			}
		},

		render: function(data) {
			if(DEBUG) console.log('$.fn.StickyAddToCart render');
			data = data || this.config;

			if(this.container)
				this.container.remove();
			this.container = $(this.compiledTemplate(data)).appendTo('body');
			this.updateView();
			this.isToolTipEnabled();
			$(this.config.errorMessaging.idName).foundation();
		},

		updateView: function(size) {
			var self = this;
			size = size || screenSize.size();
			if(DEBUG) console.log('$.fn.StickyAddToCart updateView');
			if( !this.container ){
				return;
			}

			if(self.$element.length > 0  && !self.$element[0].isConnected) {
				self.$element = $(self.config.elementSelector);
			}
			// If the normal add to cart button is disabled, hide the sticky button
			if(self.$element.hasClass('disabled') || self.$element.prop('disabled')) {
				if (!(this.config.signInButtonConfig.enabled && this.$signInButton.length > 0)) { // Only hide it, when there is no sign-in
					this.container.addClass('hide');
					return;
				}
			}
			if( this.config.sizeSelection.enabled && this.isSelectionOutOfStock){
				this.container.addClass('hide');
				return;
			}
			if (this.config.signInButtonConfig.enabled &&
				this.config.signInButtonConfig.hideStickyOnMobile &&
				this.$signInButton.length !== 0
			) {
				this.container.addClass('hide');
				return;
			}

			var $buttonElement = self.$element;
			if( this.config.signInButtonConfig.enabled && $buttonElement.css('display') === 'none' && this.$signInButton.length !== 0 ){
				$buttonElement = this.$signInButton;
			}

			var windowPos = $(window).scrollTop(),
				buttonPos = $buttonElement.offset().top,
				windowHeight = $(window).height(),
				scrollButtonLocation = windowPos > buttonPos ? 'above' : (windowPos < buttonPos - windowHeight ? 'below' : 'inview');

			if( self.config.customLocations && self.config.customLocations.length > 0){
				for(var i = 0; i < self.config.customLocations.length; i++ ){
					var currentLocation = self.config.customLocations[i];
					var $selector = $(currentLocation.selector);
					if($selector.length === 0){
						continue;
					}
					var relativePosition = $selector.offset().top;
					if( windowPos >= relativePosition - windowHeight ){ //setting the desired state if the position is inview
						scrollButtonLocation = currentLocation.state;
					}
				}
			}

			if(this.config.showFor.indexOf(size) > -1) {
				this.container.removeClass(function() {
					return Object.keys(self.config.location).reduce(function(prev, cur) {
						return prev += ' ' + self.config.location[cur];
					}, 'hide');
				}).addClass(this.config.location[scrollButtonLocation]);
			} else {
				this.container.addClass('hide');
			}

			// If the Sticky bar is inside footer, hide the sticky bar
			var stickyButton = this.container.find('#sticky-add-to-cart-button');
			var stickyButtonPos = stickyButton.offset().top,
					stickyButtonHeight = stickyButton.outerHeight(),
					footerPos = $('.footer').offset().top;

			// Using visibility instead of class hide (display: none)
			// because display:none remove the element from document result in its position set to 0
			if ((stickyButtonPos + stickyButtonHeight) >= footerPos) {
				this.container.css("visibility", "hidden");
			} else {
				this.container.css("visibility", "visible");
			}
		},

		updateButtonText: function(text) {
			this.data.buttonText = text || this.config.buttonText;
		},

		updateAll: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart updateAll');
			this.updateSizeSelection();
			this.updateSelectedColorSwatch();
			this.updateProductName();
			this.updateProductColor();
			this.updateProductSize();
			this.updateProductPrice();
			this.updateProductPromo();
			this.updateProductQuantity();
			this.updateButtonText();
			this.render();
			this.updateAddToFavorites();
			this.toggleWishlistButtonVisibility();
		},

		isToolTipEnabled: function() {
			var self = this;
			var tooltip = false;
			$.each(self.config.navigation.links, function(i, obj) {
				if(obj.tooltip.enabled) {
					tooltip = true;
				}
			});

			if(tooltip === true) $.pubsub('publish', 'STICKYCART_TOOLTIPSTERS');
		},

		isSticky: function() {
			var self = this;
			if($(self.config.containerClass).hasClass('hide')) {
				self.config.isSticky = false;
			}else{
				self.config.isSticky = true;
			}
		},

		scrollToError: function(data) {
			var selectionObj = data.unselectedSizes;
			var firstUnselected = $(selectionObj[0]);

			$('html, body').animate({
				scrollTop: firstUnselected.offset().top - firstUnselected.outerHeight(true)
			}, 'slow');
		},

		toggleSignInVisibility: function (msg, signInData) {
			var self = this;
			if(signInData.wasHover === true) {
				return;
			}
			var $stickyButton =  $('#sticky-add-to-cart-button');
			if( $stickyButton.length === 0 ){
				return;
			}
			var stickyBackground;
			if (signInData.signInVisible === true) { // Copy the title and background of the sign in button
				self.originalText = self.config.buttonText;
				self.config.buttonText = self.$signInButton.text();
				stickyBackground = self.$signInButton.css('background-color');
			} else { // Restore the standard CTA label and background
				self.config.buttonText =  $(self.element).text(); // Read text directly from the Add to Cart button
				stickyBackground = $(self.element).css('background-color');
			}
			$stickyButton.find('.sticky-text').text(self.config.buttonText);
			$stickyButton.css('background-color', stickyBackground);
			self.updateButtonText();
		},

		scrollToAttrContainer: function(attrContainerSelector) {
			var $attrContainer = $(attrContainerSelector);
			var containerTop = $attrContainer.offset().top;
			var containerHeight = $attrContainer.outerHeight();
			$('html, body').animate({
				scrollTop: containerTop - containerHeight
			}, 500);
		},

		bindEventHandlers: function() {
			if(DEBUG) console.log('$.fn.StickyAddToCart bindEventHandlers');
			var self = this;

			// Listen for a swatch change
			$.pubsub('subscribe', 'product-form.attr.swatch.click', function(msg, data) {
				self.updateAll();
			});
			// Listen for all product form changes to complete
			$.pubsub('subscribe', 'WCS.PRODUCTFORM.ATTRIBUTE.CHANGE.COMPLETE', function(msg, data) {
				if(data.originateFromClick || self.config.sizeSelection.isDropdown) {
					self.updateSizeSelection(data);
					self.updateAll();
				}
			});
			// Listen for a price change
			$.pubsub('subscribe', 'product.price.updated', function(msg, data) {
				self.updateProductPrice();
				if (self.container) {
					self.container.find('.product-price').html(self.config.price);
				}
			});
			// Listen for a click on the add to cart button
			$(document).on('click', '#sticky-add-to-cart-button', function(event) {
				event.preventDefault();
				// Pass the click onto the actual add to cart button

				var $addToCart = $(self.config.elementSelector);
				if ($addToCart.is(':hidden') === true && self.config.signInButtonConfig.enabled ) {
					if (self.$signInButton.is(':visible') === true) {
						self.$signInButton.trigger('click');
					}
				}
				else {
					$addToCart.trigger('click');
				}

				// Scroll on Sticky Add To Cart Click
				if(self.config.scrollOnAddToCartAction.enabled) {
					var pos = self.config.scrollOnAddToCartAction.selector.length > 0 ?
						$(self.config.scrollOnAddToCartAction.selector).position().top
						: $(self.element).position().top;

					$('body, html').animate({ scrollTop: pos }, self.config.scrollOnAddToCartAction.duration);
				}
			});

			// Listen for a click on the add to favorites button
			$(document).on('click', '#sticky-favorites-button', function(event) {
				event.preventDefault();

				// Pass wishlist click to PDP
				$.pubsub('publish','STICKYCART.WISHLIST.CLICKED', {
					"suppressNotification" : true
				});
			});
			// Listen for a window resizing
			$.pubsub('subscribe', 'window.resize.breakpoint', function(msg, data){
				self.updateView(data.now);
			});
			// Listen for window scrolling
			$(window).on('scroll', function() {
				self.updateView();
				self.isSticky();
			});

			$.pubsub('subscribe', 'WISHLIST_UPDATED.add', function(msg, data) {
				self.isFavored = true;
				self.toggleFavoriteState();
			});

			$.pubsub('subscribe', 'WISHLIST_UPDATED.remove', function(msg, data) {
				self.isFavored = false;
				self.toggleFavoriteState();
			});

			if(self.config.quantity.enabled) {
				var blur = false;
				//listen for qty change
				$(document).on('focusout', self.config.quantity.className, function(e) {
					if(!blur) {
						blur = true;
						if(self.config.isSticky) {
							self.config.quantity.stickyValue = $(e.currentTarget).val();
						}
						self.updateAll();
						blur = false; //prevents removeChild node errors
					}
				});

				//listen for qty keyup
				$(document).on('keyup', self.config.quantity.idName, function(e) {
					$.pubsub('publish', 'WCS.PRODUCTFORM.QUANTITY.KEYUP', e.currentTarget);
				});

				//listen for mouseleave so you don't have to click to regain focus before adding to cart
				$(document).on('mouseout', self.config.quantity.idName, function(e) {
					if(!self.config.quantity.errorState) $(this).focusout();
				});

				$.pubsub('subscribe', 'WCS.PRODUCTFORM.QUANTITY.ERROR', function(msg, error) {
					if(error === 'show') {
						self.config.quantity.errorState = true;
					} else if (error === 'hide') {
						self.config.quantity.errorState = false;
					}
				});
			}

			$.pubsub('subscribe', 'WCS.PRODUCTFORM.ERRORMESSAGE', function(msg, error) {
				var $modal = $(self.config.errorMessaging.idName);
				if(self.config.isSticky) {
					$modal.find(self.config.errorMessaging.className).html(error).end().foundation('open');

					$($modal).on('open.zf.reveal', function(e) {
						$modal.removeClass('hide');
					});
				}
			});

			if (self.config.productPromo.enabled) {
				$.pubsub('subscribe', 'WCS.PRODUCT_FORM.PROMO.RENDER.COMPLETE', function() {
					self.updateAll();
				});
			}

			if (!self.config.scrollOnAddToCartAction.enabled && self.config.scrollToError.enabled) {
				$.pubsub('subscribe', 'PDP_ADD_TO_CART_UNSELECTED_SIZES', function(msg, data) {
					self.scrollToError(data);
				});
			}

			if(self.config.signInButtonConfig.enabled) {
				$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.SIGNIN.VISIBILITY.CHANGE', self.toggleSignInVisibility.bind(self));
			}

			if (self.config.img.scrollOnClick) {
				$(document).on('click', '.product-swatch', function(event) {
					self.scrollToAttrContainer('.attr-color-js');
				});
			}

			if (self.config.sizeSelection.scrollOnClick) {
				$(document).on('click', '.product-size', function(event) {
					self.scrollToAttrContainer('.attr-size');
				});
			}
			this.initSizeSelection();
		}
	};

	StickyAddToCart.prototype = $.extend({}, HBCore, StickyAddToCart.prototype);

	$.fn.StickyAddToCart = function(options) {
		if(DEBUG) console.log('$.fn.StickyAddToCart', options);
		var args = arguments;

		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new StickyAddToCart(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER, instance);
			}
			// Call a method
			if(typeof options === 'string' && instance.hasOwnProperty(options) && typeof instance[options] === 'function') {
				instance[options].apply( instance, Array.prototype.slice.call( args, 1 ));
			}
		});
	};
});
